<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-btn icon @click="gotoUsers()">
								<v-icon>arrow_back_ios</v-icon>
							</v-btn>
							<v-toolbar-title v-if="isEdit">Düzenle</v-toolbar-title>
							<v-toolbar-title v-if="!isEdit">Ekle</v-toolbar-title>
							<v-spacer></v-spacer>
							<!-- <v-btn v-if="!isLoading" icon>
								<v-icon>add_circle</v-icon>
							</v-btn> -->
						</v-toolbar>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">İşlem devam ediyor</div>
							</div>
						</template>
						<template v-if="!isLoading">

							<v-list>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<v-flex xs12>
												<v-text-field label="Email adresi" v-model="user.nickname"
													:suffix="'@'+domain" :disabled="isEdit" />
											</v-flex>
											<v-flex xs12>
												<v-text-field v-model="user.password" append-outer-icon="lock"
													label="Yeni şifre" placeholder="Boş bırakılırsa bir işlem yapılmaz"
													type="text" :hint="getRememberPassword" persistent-hint>
												</v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field label="Adı" v-model="user.name.first"></v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field label="Soyadı" v-model="user.name.last"></v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-select :items="genders" item-text="text" item-value="value"
													label="Cinsiyet" v-model="user.gender" />
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field label="Doğum Tarihi (yyyy-mm-dd)" v-model="user.birthday"
													placeholder="YYYY-MM-DD"></v-text-field>
											</v-flex>
										</v-layout>
										<v-card-actions p-3 v-if="isEdit">
											<v-btn color="error" ml-3 @click="removeDialog = true">Sil</v-btn>
											<v-spacer></v-spacer>
											<v-btn color="success" @click="saveUser()">KAYDET</v-btn>
										</v-card-actions>
										<v-card-actions p-3 v-if="!isEdit">
											<v-spacer></v-spacer>
											<v-btn color="success" @click="addUser()">EKLE</v-btn>
										</v-card-actions>
									</v-container>
								</v-card-text>

							</v-list>
						</template>
					</v-card>
				</v-flex>



				<v-dialog v-model="removeDialog" max-width="380">
					<v-card>
						<v-card-title class="headline">Silmek istediğine emin misin ?</v-card-title> 
						<v-card-actions>
							<v-spacer></v-spacer> 
							<v-btn color="warning" flat="flat" @click="removeDialog = false"> VAZGEÇ </v-btn> 
							<v-btn color="error" @click="removeUser()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>


			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "MailOrganizations",

		data: () => ({
			isLoading: true,

			account: "",
			domain: "",
			domain_id: "",
			user_id: "",

			genders: [{
					value: "male",
					text: "Erkek",
				},
				{
					value: "female",
					text: "Kadın",
				}
			],

			isUser: true,
			isEdit: true,


			user: {},

			removeDialog : false,

		}),

		mounted() {
			this.loadIt();
		},

		methods: {
			loadIt() {
				this.account = this.$route.query.account
				this.domain = this.$route.query.domain
				this.domain_id = this.$route.query.domain_id
				this.user_id = this.$route.query.user_id
				if (this.user_id == "") {
					this.user = {
						nickname: "",
						name: {
							first: "",
							last: ""
						},
						gender: "male",
						birthday: "1980-08-08",
						remember_password: ""
					}
					this.isEdit = false;
					this.isLoading = false;
				} else {
					this.isLoading = true;
					this.$http.get(process.env.VUE_APP_API_URL + "/email/users/info", {
						params: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
							user_id: this.user_id
						}
					}).then(response => {
						this.user = response.body;
						this.isEdit = true;
						this.isLoading = false;
					})
				}
				this.user.password = "";
			},
			addUser() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/email/users/add", this.user, {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: this.user_id
					}
				}).then(response => {
					this.user = response.body; 
					this.isLoading = false;
					this.$router.push({
						path: '/email/users',
						query: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
						}
					})
				})
			},
			saveUser() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/email/users/edit", this.user, {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: this.user_id
					}
				}).then(response => {
					this.user = response.body; 
					this.isLoading = false;
					this.loadIt();
				})
			},
			removeUser(){
				this.removeDialog = false;
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/email/users/remove", {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: this.user_id
					}
				}).then(response => {
					this.user = response.body; 
					this.isLoading = false;
					this.$router.push({
						path: '/email/users',
						query: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
						}
					})
				})
			},
			gotoUsers(){
				this.$router.go(-1)
			}
		},

		computed: {
			getRememberPassword() {
				if (this.isEdit) {
					var pass = this.user.remember_password || ""
					return "Bilinen son şifre <b>" + pass + "</b>";
				}
				return ""
			}
		}

	}
</script>